"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieDomain = void 0;
var getCookieDomain = function () {
    var domainUrl = "".concat(window.location.protocol, "//").concat(window.location.hostname);
    var cookieDomain = domainUrl.replace(/(^\w+:|^)\/\//, '');
    // replace first word before "." (e.g. user) in QA and Prod
    if (cookieDomain.includes('.')) {
        cookieDomain = cookieDomain.split(/\.(.+)/)[1];
    }
    return cookieDomain;
};
exports.getCookieDomain = getCookieDomain;
//# sourceMappingURL=CookieUtils.js.map